/* sugar:assets/collapsible-row-more.js@2.0.0 */
/* Collapsible Row List: Show more / Show less. The rows past the first N are hidden by the
   block's stylesheet from the first paint; this only flips the list's data-crl-open attribute,
   the button's aria-expanded and its label. In the theme editor, selecting a hidden row opens
   the list so the row can be seen. */
(function () {
  if (window.SugarCollapsibleMore) return;

  function listFor(btn) {
    return document.getElementById(btn.getAttribute('aria-controls'));
  }

  function set(btn, open) {
    var list = listFor(btn);
    if (!list) return;
    if (open) list.setAttribute('data-crl-open', '');
    else list.removeAttribute('data-crl-open');
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    btn.textContent = btn.getAttribute(open ? 'data-label-less' : 'data-label-more');
  }

  function bind(root) {
    var btns = (root || document).querySelectorAll('[data-crl-more]');
    for (var i = 0; i < btns.length; i++) {
      var btn = btns[i];
      if (btn._crlBound) continue;
      btn._crlBound = true;
      btn.addEventListener('click', function (e) {
        var b = e.currentTarget;
        var open = b.getAttribute('aria-expanded') !== 'true';
        set(b, open);
        if (!open) {
          var r = b.getBoundingClientRect();
          if (r.top < 0) b.scrollIntoView({ block: 'center' });
        }
      });
    }
  }

  window.SugarCollapsibleMore = { bind: bind };
  bind(document);
  document.addEventListener('shopify:section:load', function (e) { bind(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var list = t.closest('[data-crl-from]');
    if (!list || list.hasAttribute('data-crl-open') || t.offsetParent !== null) return;
    var btn = document.querySelector('[data-crl-more][aria-controls="' + list.id + '"]');
    if (btn) set(btn, true);
  });
})();
